<template>
    <v-card class="panelBlock">
        <v-flex tag="h2">Forum Quicklinks</v-flex>
        <v-flex class="forum-quicklinks">
            <v-flex v-for="(resourceLink,index) in resourceLinks.filter(l => !FORUM_LINKS_REMOVED.includes(l.name))" :key="index">
                <!-- <a :href="resourceLink.url" target="_blank" 
                :data-qe-id="`forum-quick-link_${getForumQuickLink_Formater(resourceLink.name)}`">
                    {{resourceLink.name}}
                </a> -->
                <a :href="`#/speakerPage/SearchSpeakers?speakersWhoAre=${SpeakerApplicants.IS_CFF_SPEAKER}`" v-if="resourceLink.name.toLowerCase() === SpeakerApplicants.FIND_A_CFF.toLowerCase()"
                        :data-qe-id="`forum-quick-link_${getForumQuickLink_Formater(resourceLink.name)}`">
                        {{resourceLink.name}}
                </a>
                <a :href="resourceLink.url" :target="linkTarget" v-else
                :data-qe-id="`forum-quick-link_${getForumQuickLink_Formater(resourceLink.name)}`"
                :id="`forum_link_unitTest_${index}`">
                    {{resourceLink.name}}
                </a>
            </v-flex>
            <!-- <v-flex>
                    <a :href="resourceLinks.FIND_A_CFF" target="_blank"
                       data-qe-id="forum-quick-link_find-cff_link">
                        {{ForumLinkTexts.FIND_A_CFF}}
                    </a>
                </v-flex>
                <v-flex>
                    <a :href="resourceLinks.FIND_A_RETREAT" target="_blank"
                       data-qe-id="forum-quick-link_find-retreat_link">
                        {{ForumLinkTexts.FIND_A_RETREAT}}
                    </a>
                </v-flex>
                <v-flex>
                    <a :href="resourceLinks.MODERATING_MATERIALS" target="_blank"
                       data-qe-id="forum-quick-link_materials_link">
                        {{ForumLinkTexts.MODERATING_MATERIALS}}
                    </a>
                </v-flex>
                <v-flex>
                    <a :href="resourceLinks.JOINING_FORUM" target="_blank"
                       data-qe-id="forum-quick-link_joining-forum_link">
                        {{ForumLinkTexts.JOINING_FORUM}}
                    </a>
                </v-flex>
                <v-flex>
                    <a :href="resourceLinks.ABOUT_FORUM" target="_blank"
                       data-qe-id="forum-quick-link_about-forum_link">
                        {{ForumLinkTexts.ABOUT_FORUM}}
                    </a>
                </v-flex> -->
        </v-flex>
    </v-card>
</template>

<script>
    import { ForumLinks, ForumLinkTexts, FORUM_LINKS_REMOVED } from "../ForumPage/ForumConstants";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import { storeAction } from "../../store/storeActions.constant";
    import { mapGetters, mapActions } from "vuex";
    import { storeGetters } from '../../store/storeGetters.constant';

    export default {
        name: 'ForumQuickLinks',

        data() {
            return {
                ForumLinks,
                ForumLinkTexts,
                FORUM_LINKS_REMOVED,
                SpeakerApplicants,
            };
        },
        created() {
            this.getForumQuickLinks();
        },
        methods: {
            ...mapActions({
                getForumQuickLinks: `forum/${storeAction.getForumQuickLinks}`,
            }),
            getForumQuickLink_Formater(name) {
                return name.replace(/\s/g, "_");
            },
        },
        computed: {
            ...mapGetters({
                resourceLinks: `forum/${storeGetters.forumQuickLinks}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            linkTarget() {
                //navigating links to open in same tab for mobile Hybrid app
                return this.isMobileAppBrowser ? '_self' : '_blank';
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .forum-quicklinks {
        margin-top: 10px;

        .flex {
            border-bottom: 1px solid $ypo-tile-border;
            margin: 0 20px;

            a {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 14px;
                line-height: 18px;
                text-decoration: none;
                display: inline-block;
                padding: 15px 0px;
                transition: 0.3s;

                &:hover {
                    color: $ypo_blue;
                }
            }
        }
    }
</style>
